module.exports = __webpack_public_path__ + "img/ico_rr.51b21afc.png";